(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CommissionController', CommissionController);

    CommissionController.$inject = ['$rootScope', '$scope', '$state', 'Commission', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CommissionCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'ServantCustom', 'ServiceAddOnCustom', '$uibModal'];

    function CommissionController($rootScope, $scope, $state, Commission, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CommissionCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, ServantCustom, ServiceAddOnCustom, $uibModal) {

        var vm = this;
        vm.commission = entity;
        vm.servantList = {};
        vm.serviceList = {};
        vm.serviceAddOnList = {};
        vm.lastCommission = null;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.newCommissionItem = newCommissionItem;
        vm.deleteItem = deleteItem;
        vm.selectBatchItem = selectBatchItem;
        vm.onServant_changed = onServant_changed;
        vm.itemListEmptyMessage = 'هیچ آیتمی انتخاب نشده است';

        initDefault();
        loadAll();


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;

        function initDefault() {


            if (!vm.commission)
                vm.commission = {};

            if (!vm.commission.status)
                vm.commission.status = 'ACTIVE';


            $rootScope.$broadcast('hideNavBar');

        }

        function loadAll() {
            $translatePartialLoader.addPart('servant');
            // $translatePartialLoader.addPart('CommissionTypes');
            // $translatePartialLoader.addPart('CommissionPeriod');

            angular.forEach(vm.commission.items, function (item) {
                item.randomNo = Math.floor(Math.random() * 10000);
            });

            getAllServant();
            getAllServiceItem();
            getAllServiceAddOn();
        }

        function getAllServant() {
            ServantCustom.findServantsByCompany().query(function (result) {
                vm.servantList = result;
            })
        }

        function getAllServiceItem() {
            ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (result) {
                vm.serviceList = result;

            })
        }

        function getAllServiceAddOn() {
            ServiceAddOnCustom.getActiveServiceAddOns().query(function (result) {
                vm.serviceAddOnList = result;

            })
        }

        function save() {
            vm.isSaving = true;

            if (vm.commission.id !== null) {
                Commission.update(vm.commission, onSaveSuccess, onSaveError);
            } else {

                Commission.save(vm.commission, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:commissionUpdate', result);
                vm.commission = result;
                $state.go('supplierPanel-v2.editCommission', {id: result.id});
                vm.isSaving = false;

                loadAll();

            }

        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.commissionList');

        }

        function getModalTitle() {
            if (vm.commission.id)
                return 'tikonApp.commission.home.edit';
            else
                return 'tikonApp.commission.home.new';
        }

        function newCommissionItem(type, referencedId) {

            var item = {};
            item.amount = 0;
            item.type = type;
            item.commissionType = 'PERCENT';

            if (!vm.commission.items)
                vm.commission.items = [];

            item.randomNo = Math.floor(Math.random() * 10000);

            if (referencedId)
                item.referencedItemId = referencedId;

            vm.commission.items.push(item);

        }

        function deleteItem(item) {
            vm.commission.items = vm.commission.items.filter(function (commissionItem) {
                if (commissionItem.randomNo != item.randomNo)
                    return commissionItem;
            })
        }

        function selectBatchItem() {
            $rootScope.modalInstance = $uibModal.open({
                templateUrl: 'app/entities/commission/select-batch-item-modal.html',
                controller: 'SelectBatchItemModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'pl-modal',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });

            $rootScope.modalInstance.result.then(function (items) {

                addItemsToCommission(items);
                //reload();
            }, function () {
                //nothing
            });
        }

        function addItemsToCommission(items) {
            angular.forEach(items, function (item) {
                newCommissionItem(item.type, item.id);
            });
        }

        function onServant_changed() {

            if (!vm.commission.servant.id)
                return;
            vm.lastCommission = null;

            CommissionCustom.getLastServantCommission(vm.commission.servant.id).query(function (result) {

                if (!result.id) {
                    return;
                }

                if (result.id != vm.commission.id || !vm.commission.id)
                    vm.lastCommission = result;
                else
                    vm.lastCommission = null;
            })
        }
    }
})();
